<ngx-loading-bar
  #loading
  color="#3AA36B"
  includeSpinner="false"
  height="3px"
></ngx-loading-bar>

<div id="service-order-new">
  <app-new [title]="title" [subtitle]="subtitle" [urlBack]="urlBack">
    <div class="container" [formGroup]="newServiceOrder">
      <div class="row">
        <div class="col">
          <label>
            <span>BANDEIRA</span>

            <select
              formControlName="cdBandeira"
              (change)="getStores($event.target.value)"
            >
              <option value="">Selecione a bandeira</option>
              <option
                *ngFor="let flag of flagsArr"
                [value]="flag.cdLogomarca"
                >{{ flag.dsLogomarca }}</option
              >
            </select>
          </label>
        </div>

        <div class="col">
          <label>
            <span>LOJA</span>

            <select formControlName="cdFilial">
              <option value="" *ngIf="storesArr.length == 0"
                >Selecione uma bandeira</option
              >
              <option value="" *ngIf="storesArr.length > 0"
                >Selecione a loja</option
              >
              <option
                *ngFor="let store of storesArr"
                [value]="store.cdFilial"
                >{{ store.nmFantasia }}</option
              >
            </select>
          </label>
        </div>

        <div class="col">
          <label>
            <span>LOJA NOVA</span>
            <select [disabled]="true">
              <option value="não">Não</option>
            </select>
          </label>
        </div>
      </div>

      <div class="row" *ngIf="newServiceOrder.value.lojaNova == 'não'">
        <!-- Select de equipamentos-->
        <!-- <div class="col">
          <label>
            <span>EQUIPAMENTO</span>

            <select
              formControlName="cdProduto"
              (change)="getServiceProviders($event.target.value)"
            >
              <option value="">Selecione o equipamento</option>
              <option
                *ngFor="let equipment of equipmentsArr"
                [value]="equipment.cdProduto"
                >{{ equipment.dsProduto }}</option
              >
            </select>
          </label>
        </div> -->

        <div class="col">
          <label>
            <span>PRESTADOR DE SERVIÇO</span>

            <select formControlName="cdFornecedor">
              <option value="" *ngIf="providersArr.length == 0"
                >Selecione um equipamento</option
              >
              <option value="" *ngIf="providersArr.length > 0"
                >Selecione o prestador de serviço</option
              >
              <option
                *ngFor="let provider of providersArr"
                [value]="provider.cdFornecedor"
                >{{ provider.nmRazaoSocial }}</option
              >
            </select>
          </label>
        </div>

        <div class="col">
          <label>
            <span>TIPO DE SERVIÇO</span>

            <select disabled>
              <option>Manutenção</option>
            </select>
          </label>
        </div>
      </div>

      <div class="row" *ngIf="newServiceOrder.value.lojaNova == 'não'">
        <div class="col">
          <label id="equipment_label">
            <span>EQUIPAMENTO</span>
          </label>

          <div id="list" (change)="getServiceProviders($event.target.value)">
            <table width="100%" class="table">
              <thead>
                <tr>
                  <th>
                    <div>ID</div>
                  </th>
                  <th>
                    <div>Produto</div>
                  </th>
                  <th>
                    <div>Número Item</div>
                  </th>
                  <th>
                    <div>Valor Item</div>
                  </th>
                </tr>
              </thead>

              <tbody>
                <ng-container *ngFor="let eq of equipments; let i = index">
                  <tr>
                    <td>
                      {{ eq.cdProduto }}
                    </td>
                    <td>
                      {{ eq.dsProduto }}
                    </td>
                    <td>
                      {{ eq.nrItem }}
                    </td>
                    <td>
                      {{ eq.vlItem | currencyFormat: "pt-BR" }}
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label>
            <span>RELATO DO CHAMADO</span>

            <textarea formControlName="dsObservacao"></textarea>
          </label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <button (click)="saveServiceOrder()">SALVAR ORDEM DE SERVIÇO</button>

          <button class="red" [routerLink]="returnLink">REJEITAR</button>
        </div>
      </div>
    </div>
  </app-new>
</div>
